import React from 'react';
import styles from './PinnedContentSection.module.scss';

const PinnedContentSection: React.FC<{ children: React.ReactNode; count: number }> = ({ children, count }) => (
  <section className={styles.section} aria-label="Pinned content">
    <div className={styles.header}>
      <span className={styles.icon} aria-hidden="true">📌</span>
      <span>Pinned content</span>
      <span className={styles.count}>{count}</span>
    </div>
    <div className={styles.items}>{children}</div>
  </section>
);

export default PinnedContentSection;
